import metadata from './request'
import api from './Url'
import { UserServiceClient } from '../pbs/user_grpc_web_pb'
import {UserLoginSummaryReq} from "../pbs/user_pb"

const service = new UserServiceClient(api,null,null)

/**
 * 获取汇总数据
 */
export function getdatalist(data) {
  return new Promise((resolve, reject) => {
    const request = new UserLoginSummaryReq()
    request.setPageNumber(data.pagesize)
    request.setPageSize(data.pageNumber)
    service.getLoginSummary(request, metadata(), (err, response) => {
      if (!err) { // 获取成功
        resolve(response.toObject())
      } else { // 请求失败
        reject(err)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/data.js